import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { Button } from "../utils/Button";
import { GameManager } from "../GameManager";
import { AudioManager } from "../AudioManager";

export class LowerMenu extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.y = GameConstants.GAME_HEIGHT - 117 * GameVars.scaleY;
        this.scaleY = GameVars.scaleY;

        const menuBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "menu_base");
        menuBackground.setScale(GameConstants.GAME_WIDTH / menuBackground.width, 1);
        menuBackground.setOrigin(0);
        this.add(menuBackground);

        let divider = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 3, menuBackground.height / 2, "texture_atlas_1", "menu_divider");
        this.add(divider);

        divider = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH * 2 / 3, menuBackground.height / 2, "texture_atlas_1", "menu_divider");
        this.add(divider);

        const buttonHome = new Button(this.scene, GameConstants.GAME_WIDTH / 6,  menuBackground.height / 2, "texture_atlas_1", "btn_menu_home_icon_disabled_off", "btn_menu_home_icon_disabled_on");
        buttonHome.onDown(this.onClickHome, this);
        this.add(buttonHome);

        const iconHome = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 6,  menuBackground.height / 2, "texture_atlas_1", "btn_menu_home_icon_active");
        this.add(iconHome);

        const buttonShop = new Button(this.scene, GameConstants.GAME_WIDTH / 2,  menuBackground.height / 2, "texture_atlas_1", "btn_menu_shop_icon_disabled_off", "btn_menu_shop_icon_disabled_on");
        buttonShop.onDown(this.onClickShop, this);
        this.add(buttonShop);

        const iconShop = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2,  menuBackground.height / 2, "texture_atlas_1", "btn_menu_shop_icon_active");
        this.add(iconShop);

        const buttonInstructions = new Button(this.scene, GameConstants.GAME_WIDTH * 5 / 6, menuBackground.height / 2, "texture_atlas_1", "btn_menu_tutorial_icon_disabled_off", "btn_menu_tutorial_icon_disabled_on");
        buttonInstructions.onDown(this.onClickInstructions, this);
        this.add(buttonInstructions);

        const iconInstructions = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH * 5 / 6,  menuBackground.height / 2, "texture_atlas_1", "btn_menu_tutorial_icon_active");
        this.add(iconInstructions);

        if (GameVars.currentScene.scene.key === "SplashScene") {
            buttonHome.visible = false;
            iconShop.visible = false;
            iconInstructions.visible = false;
        } else if (GameVars.currentScene.scene.key === "ShopScene") {
            buttonShop.visible = false;
            iconHome.visible = false;
            iconInstructions.visible = false;
        } else {
            buttonInstructions.visible = false;
            iconHome.visible = false;
            iconShop.visible = false;
        }

        // if (GameVars.tutorialMode) {
        //     this.alpha = .35;
        // }
    }

    private onClickHome(): void {

        // if (GameVars.tutorialMode) {
        //     return;
        // }

        AudioManager.playSound("click_btn");

        GameManager.enterSplashScene();
    }

    private onClickShop(): void {

        // if (GameVars.tutorialMode) {
        //     return;
        // }

        AudioManager.playSound("click_btn");
        
        GameManager.enterShopScene();
    }

    private onClickInstructions(): void {

        AudioManager.playSound("click_btn");
        
        GameManager.enterTutorialScene();
    }
}
